// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"53e9edc1","533":"82ebc322","667":"fe7ec669","713":"789f5958","850":"b8bf997b","858":"6f0a43f3","879":"62ce412a","977":"31060a63"}[chunkId] + ".chunk.js";
};